(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.observeHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      /* Widened for the BEDROCK inline bar: <bedrock-search-bar> maintains the
         same isOpen contract, and missing it here would silently kill the
         "don't hide the header while search is open" guard below. */
      this.predictiveSearch = this.querySelector('predictive-search, bedrock-search-bar');

      /* Collapse-on-scroll (BEDROCK): a parallel branch beside hide/reveal —
         under sticky-type "always" those early-return and the nav row folds
         instead. Enabled only when the section rendered the toggle button,
         so a dropdown/drawer layout can never end up with a dangling state. */
      this.navToggle = this.querySelector('.header__nav-toggle');
      this.collapseNav = this.getAttribute('data-collapse-on-scroll') === 'true' && !!this.navToggle;
      this.navManuallyOpened = false;
      if (this.collapseNav) {
        this.navToggle.addEventListener('click', this.onNavToggleClick.bind(this));
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    /* Dawn measures the header ONCE, from connectedCallback, and then only again on a
       990px media-query flip. Both are wrong here and the second hides the first.

       connectedCallback runs while the document is still parsing, before the mega-menu
       panels have been taken out of flow, so `.section-header` is measured with every
       panel stacked inside it: --header-height came out at 7986px on this store — the
       height of the whole navigation, not the bar. Nothing consumed the variable, so
       the value sat wrong and invisible until the collection toolbar tried to stick
       beneath it (`top: 7986px` pins a sticky element to the bottom of its container —
       the toolbar rendered below the product grid) and the sidebar's
       `max-height: calc(100vh - var(--header-height) - 9rem)` went negative, clamped to
       0, and hid the filters entirely with `overflow: auto`.

       A ResizeObserver replaces both triggers and covers what neither did: first paint,
       any resize, and the collapse-on-scroll fold — which changes the header's height on
       this store on every scroll, and which no media query fires for. */
    observeHeaderHeight() {
      if (!('ResizeObserver' in window)) return;
      this.heightObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.heightObserver.observe(this.header);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.heightObserver?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.collapseNav) this.updateNavCollapse(scrollTop);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    onNavToggleClick() {
      const opened = this.header.classList.toggle('header--nav-open');
      this.navManuallyOpened = opened;
      this.navToggle.setAttribute('aria-expanded', opened);
    }

    updateNavCollapse(scrollTop) {
      if (scrollTop > this.headerBounds.bottom) {
        /* Never fold the row out from under an open panel — the panels are
           anchored to (and would be clipped by) the very row being folded. */
        if (
          document.body.classList.contains('has-dropdown-menu') ||
          document.body.classList.contains('bedrock-search-open')
        ) {
          return;
        }
        if (!this.header.classList.contains('header--nav-collapsed')) {
          this.header.classList.add('header--nav-collapsed');
          this.navToggle.hidden = false;
        }
        if (!this.navManuallyOpened) {
          this.header.classList.remove('header--nav-open');
          this.navToggle.setAttribute('aria-expanded', 'false');
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('header--nav-collapsed', 'header--nav-open');
        this.navToggle.hidden = true;
        this.navToggle.setAttribute('aria-expanded', 'false');
        this.navManuallyOpened = false;
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
